import { SET_COUPON_CODE } from '@/constants';

export const setUserCouponCode = (couponData) => ({
    type: SET_COUPON_CODE,
    couponData
});
